import {Component, OnInit} from '@angular/core';
import {TopManagementService} from '../_services/top-management.service';
import {ViewManagementModel} from '../_models/viewManagement.model';

@Component({
    selector: 'app-list-others',
    templateUrl: './list-others.component.html',
    styleUrls: ['./list-others.component.scss']
})

export class ListOthersComponent implements OnInit {

    constructor(private topManagementService: TopManagementService) {
    }

    filterObjectData: object;
    filteredData: ViewManagementModel[];

    // Pagination
    page = 1; // Page selected at start
    pageSize = 8; // How many post per page

    // Sorting
    sortName = 'date'; // Sorting Name Input
    sortDirOrder = 'desc'; // Sorting Order
    totalElements: number; // Total Elements you get from the request

    ngOnInit() {
        this.listTMFilter()
    }

    listTMFilter() {

        this.filterObjectData = {
            categories: [
                'alte'
            ]
        }

        this.topManagementService.listTopManagementFilter(this.pageSize, this.page, this.sortName, this.sortDirOrder, this.filterObjectData).subscribe((resp: any) => {
            this.filteredData = resp.content;
            this.totalElements = resp.totalElements;
        })
    }

    onPageChange(page: number) {
        this.page = page;
        this.listTMFilter();
    }

    selectPageElements(event: any) {
        this.pageSize = event.target.value;
        this.page = 1;
        this.listTMFilter();
    }

    selectSortValue(event: any) {
        this.sortName = event.target.value;
        this.page = 1;
        this.listTMFilter();
    }

    changeOrderDirection(event: any) {
        this.sortDirOrder = event.target.value;
        this.page = 1;
        this.listTMFilter();
    }


}
